<script setup lang="ts">
import { AccordionContent, AccordionItem, AccordionTrigger } from './internal'
import type { HTMLAttributes } from 'vue'
import { cn } from '@/utils/shadcn/lib/utils.ts'
import { computed } from 'vue'
import generateId from '@/utils/generateId.ts'

defineOptions({
    compatConfig: {
        MODE: 3,
    },
})

const props = withDefaults(defineProps<{
    class?: HTMLAttributes['class']
    value?: string
    label?: string
}>(), {
    class: '',
    value: '',
    label: '',
})

const modelValue = defineModel<string | string[]>('modelValue')

const value = computed(() => props.value || generateId('accordion-item-'))

</script>

<template>
    <AccordionItem
        v-model="modelValue"
        :value="value"
        :unmount-on-hide="false"
        collapsible
        :class="cn('border border-transparent border-b-input-dark has-[:focus-visible]:border-ring/50! has-[:focus-visible]:rounded-md', props.class)"
    >
        <AccordionTrigger
            data-slot="accordion-trigger"
            class="text-base font-semibold text-foreground px-2"
        >
            <slot name="label">
                {{ props.label }}
            </slot>
        </AccordionTrigger>
        <AccordionContent
            data-slot="accordion-content"
            class="text-base px-2"
        >
            <slot></slot>
        </AccordionContent>
    </AccordionItem>
</template>
